export enum MenuProfileIds {
	PROFIL = "PROFIL",
	PROFIL_AGATHE_YOU = "PROFIL_AGATHE_YOU",
	PROFIL_OPALINE = "PROFIL_OPALINE",
	ESPACE_CLIENT = "ESPACE_CLIENT",
	PREFERENCES = "PREFERENCES",
	PREFERENCES_MON_LECTEUR = "PREFERENCES_MON_LECTEUR",
	PREFERENCES_MES_SOINS_FAVORIS = "PREFERENCES_MES_SOINS_FAVORIS",
	PREFERENCES_AUTRES = "PREFERENCES_AUTRES",
	FORMATION = "FORMATION",
	FORMATION_FAQ = "FORMATION_FAQ",
	FORMATION_TUTOS = "FORMATION_TUTOS",
	LIENS_UTILS = "LIENS_UTILS",
	LIENS_UTILS_PRESCRIPTEURS = "LIENS_UTILS_PRESCRIPTEURS",
	LIENS_UTILS_CAISSES = "LIENS_UTILS_CAISSES",
	LIENS_UTILS_NOMENCLATURE = "LIENS_UTILS_NOMENCLATURE",
	LIENS_UTILS_CONVENTIONNEMENT = "LIENS_UTILS_CONVENTIONNEMENT",
	LIENS_UTILS_AMELI_PRO = "LIENS_UTILS_AMELI_PRO",
	GESTION_ADMINISTRATION = "GESTION_ADMINISTRATION",
	GESTION_ADMINISTRATION_ADMIN = "GESTION_ADMINISTRATION_ADMIN",
	GESTION_ADMINISTRATION_MARKETING = "GESTION_ADMINISTRATION_MARKETING",
	GESTION_ADMINISTRATION_DEV = "GESTION_ADMINISTRATION_DEV",
}
